var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tag',{attrs:{"text":_vm.text,"icon":"/images/icons/product-giveaways.svg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }